import React, { useState, useEffect } from "react";
import "../styles/CookieConsentBanner.css";
import { Link } from "react-router-dom";

function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setIsVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem("cookiesDismissed", "true");

    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-banner">
      <p>
        This website uses essential cookies to ensure proper functionality and a
        better user experience. By continuing to use the site, you agree to
        their use. Learn more in our
        <Link to="/privacy-policy" className="cookie-policy-link">
          {" "}
          Privacy & Cookie Policy
        </Link>
        .
      </p>
      <button onClick={handleAccept} className="cookie-accept-btn">
        Accept
      </button>
      <button onClick={handleDismiss} className="cookie-dismiss-btn">
        Dismiss
      </button>
    </div>
  );
}

export default CookieConsentBanner;
